export default "__VITE_PUBLIC_ASSET__b5f89acb__"